import { createRouter, createWebHistory } from 'vue-router'

import Home from '../views/Home.vue' // 首页
import Store from '../views/Store.vue' // 精品店页面
import About from '../views/About.vue' // 关于卡宾
import Contact from '../views/Contact.vue' // 联系我们
import OfflineStore from '../views/OfflineStore.vue' // 线下门店导流
import News from '../views/News.vue' // 新闻页
import FinancialReport from '../views/FinancialReport.vue' // 财务报表
import ProductDetail from '../views/product/ProductDetail.vue' //  商品详情页路由
// ✅ 新闻详情页组件
import NewsMalaysia from '../views/news/NewsMalaysia.vue';
import NewsHKListing from '../views/news/NewsHKListing.vue';
import NewsNYShow from '../views/news/NewsNYShow.vue';
import News2024FW from '../views/news/News2024FW.vue';
import News2025ss from '../views/news/News2025ss.vue';
import NewsThumbsup from '../views/news/NewsThumbsup.vue';
import NewsBjwo from '../views/news/NewsBjwo.vue';
import Newsssunway from '../views/news/Newsssunway.vue';
import News2526FW from '../views/news/News2526FW.vue';
// ✅ 新增：品牌合作与商场招商页面
const BrandCooperation = () => import('../views/BrandCooperation.vue')
const MallLeasing = () => import('../views/MallLeasing.vue')
const Recruitment = () => import('../views/Recruitment.vue')

const routes = [
  { path: '/', component: Home },
  { path: '/store', component: Store },
  { path: '/about', component: About },
  { path: '/contact', component: Contact },
  { path: '/offline-store', component: OfflineStore },
  { path: '/news', component: News },
  { path: '/financial-report', component: FinancialReport },
  { path: '/product/detail/:id', component: ProductDetail },
    // ✅ 新增新闻详情页路由
  { path: '/news/malaysia', component: NewsMalaysia },
  { path: '/news/hk-listing', component: NewsHKListing },
  { path: '/news/ny-show', component: NewsNYShow },
  { path: '/news/2024-fw', component: News2024FW },
  { path: '/news/2025-ss', component: News2025ss },
  { path: '/news/thumbsup', component: NewsThumbsup },
  { path: '/news/bjwo', component: NewsBjwo },
  { path: '/news/sunway', component: Newsssunway },
  { path: '/news/2526-fw', component: News2526FW },
  // ✅ 联系我们子栏目
  { path: '/brand-cooperation', component: BrandCooperation },
  { path: '/mall-leasing', component: MallLeasing },
  { path: '/recruitment', component: Recruitment },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    return { top: 0 }
  },
})

export default router

